import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {
    collateralLinks: {
      link1: "#",
      link2: "#",
      link3: "#"
    },
    _id: null,
    clientName: null,
    directedTo: null,
    haveAQuoteEnabled: false,
    contactEmails: [],
    cipAccessControl: null,
    clientCode: null,
    clientType: null,
    clientIndustry: null,
    pricingMatrix: {
      enabled: false
    },
    salesPOC: null,
    addedBy: null,
    onboardingComplete: false,
    panelDashboardLink: "https://panel.jaspercolin.com/home/def",
    taasClientPricingTier: null
  },
  isLoggedIn: false,
};


export const sliceName = 'loginAuth'

export const loginAuth = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setClientCredentials: (state, action) => {
      state.user = {
        collateralLinks: {
          link1: action.payload.collateralLinks.link1,
          link2: action.payload.collateralLinks.link2,
          link3: action.payload.collateralLinks.link3,
        },
        _id: action.payload._id,
        clientName: action.payload.clientName,
        directedTo: action.payload.directedTo,
        clientCode: action.payload.clientCode,
        cipVersion: action.payload.cipVersion,
        clientType: action.payload.clientType,
        haveAQuoteEnabled: action.payload.haveAQuoteEnabled,
        haveAQuoteVersion: action.payload.haveAQuoteVersion,
        contactEmails: (action.payload.contactEmails).map(el => el.email),
        cipAccessControl: action.payload.cipAccessControl,
        clientIndustry: action.payload.clientIndustry,
        pricingMatrix: {
          enabled: action.payload.pricingMatrix.enabled
        },
        onboardingComplete: action.payload.onboarding.complete,
        panelDashboardLink: action.payload.panelDashboardLink,
        salesPOC: action.payload.salesPoc,
        taasClientPricingTier: action.payload.taasClientPricingTier,
        addedBy: action.payload.addedBy
      }
      state.isLoggedIn = true
    },
    resetClientCredentials: (state, action) => {
      return initialState;
    },
    setBecomeClient: (state, action) => {
      const { isOnboardingComplete } = action.payload
      state.user.onboardingComplete = isOnboardingComplete
    },
  }
})


export const { setClientCredentials, resetClientCredentials, setBecomeClient } = loginAuth.actions;

export const selectIsUserLoggedIn = state => state[sliceName].isLoggedIn
export const selectLoggedInUser = state => state[sliceName].user
export const selectLoggedInUserId = state => state[sliceName].user._id
export const selectHaveAQuote = state => state[sliceName].user.haveAQuoteEnabled
export const selectContactEmails = state => state[sliceName].user.contactEmails
export const selectClientCode = state => state[sliceName].user.clientCode
export const selectSalesPoc = state => state[sliceName].user.salesPOC
export const selectAddedBy = state => state[sliceName].user.addedBy
export const selectCIPVersion = state => state[sliceName].user.cipVersion


export default loginAuth.reducer;